module.exports = __webpack_public_path__ + "static/media/strikethrough.dd5e4205.png";